
<div class="row justify-content-center  p-5" *ngIf="!loaded">
    <div class="spinner-border text-primary" role="status">
        <span class="sr-only">{{ 'pages.generic.loading' | translate }}</span>
    </div>
</div>

<div class="row pt-3" *ngIf="loaded">
    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
        <p>
            The Security Incident Report shows all detected security incidents that were analyzed over a specific time frame. 
        </p>
        <p>
            True Positive incidents are security incidents that were confirmed by our analysts, often in collaboration with our customers. False Positive security incidents were concluded to be not an actual security incident but a false alarm. Confirmed security incidents (TPs) can be further broken down into 4As: <b>Actor</b> (Whose actions affected the asset?), <b>Action</b> (What actions affected the asset?), <b>Assets</b> (Which assets were affected?) and <b>Attributes</b> (How the asset was affected?). Additionally, all <b>Sub-Actions</b> can be viewed.
        </p>
        <p>
            False Positives security incidents can be broken down into 3Ws: <b>Who</b> caused it? <b>Why</b> was it caused in the first placed? <b>What</b> needs to be done further?
        </p>
        <p> 
            The Data tab provides information on ticket details of the handled security incidents
        </p>

    </div>
    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 text-center pt-2" *ngIf="loaded && errorMessage">

        <h4 style="color:red;">{{errorMessage}}</h4>

    </div>
    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12" *ngIf="loaded && !errorMessage">

        <div class="row">
            <div class="col-12">
                <h2>True Positive vs False Positive</h2>
            </div>
        </div>

        <highcharts-chart
            [Highcharts]="Highcharts"
            [options]="tpvfpDonutChartOptions"
            [(update)]="updateDonutFlag"
            [oneToOne]=true
            style="width: 100%; display: block;"
        ></highcharts-chart>

    </div>
</div>

<div class="row pt-3" *ngIf="loaded && !errorMessage">
    <div class="col-12">

        <ul class="nav nav-tabs">
            <li class="nav-item">
                <a class="nav-link" [ngClass]="{ 'active' : page === 'tp' }" (click)="page = 'tp'">True Positives</a>
            </li> 
            <li class="nav-item">
                <a class="nav-link" [ngClass]="{ 'active' : page === 'fp' }" (click)="page = 'fp'">False Positives</a>
            </li>
        </ul>
            
    </div>
</div>

<div class="row pt-3" *ngIf="loaded && !errorMessage">
    <div class="col-1"></div>
    <div class="col-10">
        
        <ul class="nav nav-tabs">
            <li class="nav-item">
                <a class="nav-link" [ngClass]="{ 'active' : subpage === 'analytics' }" (click)="subpage = 'analytics'">Analytics</a>
            </li> 
            <li class="nav-item">
                <a class="nav-link" [ngClass]="{ 'active' : subpage === 'data' }" (click)="subpage = 'data'">Data</a>
            </li>
        </ul>
            
    </div>
    <div class="col-1"></div>
</div>


<div class="row pt-4" *ngIf="loaded && page === 'tp' && subpage === 'analytics' && !errorMessage">
    <div class="col-1"></div>
    <div class="col-10">
    
        <div class="row">
            <div class="col-xl-11 col-lg-11 col-md-11 col-sm-12 col-12 text-left justify-content-left">

                <highcharts-chart
                    [Highcharts]="Highcharts"
                    [options]="catColumnChartOptions"
                    [(update)]="updateFlag"
                    [oneToOne]=true
                    style="width: 100%; height: 500px; display: block;" 
                ></highcharts-chart>

            </div>
            <div class="col-xl-1 col-lg-1 col-md-1 col-sm-12 col-12 text-center">
                <ng-template #actor> Threat Actor </ng-template>
                <ng-template #killchain> Threat Killchain </ng-template>
                <ng-template #action> Threat Action </ng-template>
                <ng-template #subaction> Threat Sub Action </ng-template>
                <ng-template #attributes> Threat Attributes </ng-template>

                <button class="btn" [ngbTooltip]="actor" (click)="updateGraph('actor')"><fa-icon [icon]="['fas', 'user']" size="2x"></fa-icon></button>
                <button class="btn" [ngbTooltip]="killchain" (click)="updateGraph('killchain')"><fa-icon [icon]="['fas', 'bullseye']" size="2x"></fa-icon></button>
                <button class="btn" [ngbTooltip]="action" (click)="updateGraph('action')"><fa-icon [icon]="['fas', 'check-square']" size="2x"></fa-icon></button>
                <button class="btn" [ngbTooltip]="subaction" (click)="updateGraph('subaction')"><fa-icon [icon]="['far', 'check-square']" size="2x"></fa-icon></button>
                <button class="btn" [ngbTooltip]="attributes" (click)="updateGraph('attributes')"><fa-icon [icon]="['fas', 'list']" size="2x"></fa-icon></button>

            </div>
        </div>

    </div>
</div>

<div class="row pt-5" *ngIf="loaded && !errorMessage">
    <div class="col-1"></div>
    <div class="col-10">
    
        <div class="row">
            <div class="col-12 text-center">
                <h2>Monthly breakdown</h2>
                <button class="btn" (click)="changeMonth('back')"><fa-icon [icon]="['fas', 'caret-square-left']" size="2x"></fa-icon></button> <span style="font-size: 1.5rem;">{{currentMonth}}</span><button class="btn" (click)="changeMonth('fwd')"><fa-icon [icon]="['fas', 'caret-square-right']" size="2x"></fa-icon></button>
            </div>
        </div>

    </div>
</div>

<div class="row pt-3" *ngIf="loaded && page === 'tp' && subpage === 'analytics' && !errorMessage">
    <div class="col-1"></div>
    <div class="col-10">

        <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12  p-0">

                <div class="row pt-5">
                    <div class="col-12 text-center">
                        <h3>Threat Actor</h3>
                    </div>
                </div>
                <div class="row p-0">
                    <div class="col-12 text-center p-0">

                        <highcharts-chart
                            [Highcharts]="Highcharts"
                            [options]="actorDonutChartOptions"
                            [(update)]="updateDonutFlag"
                            [oneToOne]=true
                            style="width: 100%; display: block;"
                        ></highcharts-chart>
            
                    </div>
                </div>

            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 p-0 text-center">

                <div class="row pt-5">
                    <div class="col-12 text-center">
                        <h3>Threat Killchain</h3>
                    </div>
                </div>
                <div class="row p-0">
                    <div class="col-12 text-center p-0">

                        <highcharts-chart
                            [Highcharts]="Highcharts"
                            [options]="killchainDonutChartOptions"
                            [(update)]="updateDonutFlag"
                            [oneToOne]=true
                            style="width: 100%; display: block;"
                        ></highcharts-chart>

                    </div>
                </div>
                
            </div>
        </div>

        <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 ">

                <div class="row pt-5">
                    <div class="col-12 text-center">
                        <h3>Threat Action</h3>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 text-center p-0">
            
                        <highcharts-chart
                            [Highcharts]="Highcharts"
                            [options]="actionDonutChartOptions"
                            [(update)]="updateDonutFlag"
                            [oneToOne]=true
                            style="width: 100%; display: block;"
                        ></highcharts-chart>
            
                    </div>
                </div>
            
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 ">
                <div class="row pt-5">
                    <div class="col-12 text-center">
                        <h3>Threat Sub Action</h3>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 text-center p-0">

                        <highcharts-chart
                            [Highcharts]="Highcharts"
                            [options]="subactionDonutChartOptions"
                            [(update)]="updateDonutFlag"
                            [oneToOne]=true
                            style="width: 100%; display: block;"
                        ></highcharts-chart>

                    </div>
                </div>

            </div>
        </div>

        <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 ">

                <div class="row pt-5">
                    <div class="col-12 text-center">
                        <h3>Threat Attributes</h3>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 text-center p-0">

                        <highcharts-chart
                            [Highcharts]="Highcharts"
                            [options]="attributesDonutChartOptions"
                            [(update)]="updateDonutFlag"
                            [oneToOne]=true
                            style="width: 100%; display: block;"
                        ></highcharts-chart>

                    </div>
                </div>

            </div>
        </div>

    </div>
</div>




<div class="row pt-3" *ngIf="loaded && page === 'fp' && subpage === 'analytics' && !errorMessage">
    <div class="col-1"></div>
    <div class="col-10">

        <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12  p-0">

                <div class="row pt-5">
                    <div class="col-12 text-center">
                        <h3>What</h3>
                    </div>
                </div>
                <div class="row p-0">
                    <div class="col-12 text-center p-0">

                        <highcharts-chart
                            [Highcharts]="Highcharts"
                            [options]="whatDonutChartOptions"
                            [(update)]="updateDonutFlag"
                            [oneToOne]=true
                            style="width: 100%; display: block;"
                        ></highcharts-chart>
            
                    </div>
                </div>

            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 p-0 text-center">

                <div class="row pt-5">
                    <div class="col-12 text-center">
                        <h3>Who</h3>
                    </div>
                </div>
                <div class="row p-0">
                    <div class="col-12 text-center p-0">

                        <highcharts-chart
                            [Highcharts]="Highcharts"
                            [options]="whoDonutChartOptions"
                            [(update)]="updateDonutFlag"
                            [oneToOne]=true
                            style="width: 100%; display: block;"
                        ></highcharts-chart>

                    </div>
                </div>
                
            </div>
        </div>

        <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 ">

                <div class="row pt-5">
                    <div class="col-12 text-center">
                        <h3>Why</h3>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 text-center p-0">
            
                        <highcharts-chart
                            [Highcharts]="Highcharts"
                            [options]="whyDonutChartOptions"
                            [(update)]="updateDonutFlag"
                            [oneToOne]=true
                            style="width: 100%; display: block;"
                        ></highcharts-chart>
            
                    </div>
                </div>
            
            </div>
        </div>

    </div>
</div>




<div class="row pt-3" *ngIf="loaded && page === 'tp' && subpage === 'data' && !errorMessage">
    <div class="col-1"></div>
    <div class="col-10">

        <div class="row">
            <div class="col-12">

                <div class="row faketableheaderrow">
                    <div class="col-xl-1 col-lg-1 col-md-2 col-sm-4 col-4 faketableheader" (click)="sortAssets('saseNumber');">
                        Case number <fa-icon [icon]="['fas', 'sort']" class="p-1"></fa-icon>
                    </div>
                    <div class="col-xl-1 col-lg-1 col-md-2 d-none d-md-block faketableheader" (click)="sortAssets('status');">
                        Status <fa-icon [icon]="['fas', 'sort']" class="p-1"></fa-icon>
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-8 col-sm-8 col-8 faketableheader" (click)="sortAssets('Ssubject');">
                        Subject <fa-icon [icon]="['fas', 'sort']" class="p-1"></fa-icon>
                    </div>
                    <div class="col-xl-2 col-lg-2 d-none d-lg-block faketableheader" (click)="sortAssets('action');">
                        Action/Sub Action <fa-icon [icon]="['fas', 'sort']" class="p-1"></fa-icon>
                    </div>
                    <div class="col-xl-2 col-lg-2 d-none d-lg-block faketableheader" (click)="sortAssets('actor');">
                        Actor <fa-icon [icon]="['fas', 'sort']" class="p-1"></fa-icon>
                    </div>
                    <div class="col-xl-2 col-lg-2 d-none d-lg-block faketableheader" (click)="sortAssets('killchain');">
                        Killchain <fa-icon [icon]="['fas', 'sort']" class="p-1"></fa-icon>
                    </div>
                </div>

                <div class="row faketablerow" *ngFor="let case of currentMonthDataTP" [routerLink]="['/support/view/' + case.id]" routerLinkActive="activeLink">
                    <div class="col-xl-1 col-lg-1 col-md-2 col-sm-4 col-4 faketablecell">
                        {{case.caseNumber}}
                    </div>
                    <div class="col-xl-1 col-lg-1 col-md-2 d-none d-md-block faketablecell">
                        {{case.status}}
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-8 col-sm-8 col-8  faketablecell">
                        {{case.subject}}
                    </div>
                    <div class="col-xl-2 col-lg-2 d-none d-lg-block faketablecell">
                        {{case.action}} / {{case.subAction}}
                    </div>
                    <div class="col-xl-2 col-lg-2 d-none d-lg-block faketablecell">
                        {{case.actor}}
                    </div>
                    <div class="col-xl-2 col-lg-2 d-none d-lg-block faketablecell">
                        {{case.killchain | replace : ';' : ','}}
                    </div>
                </div>

            </div>
        </div>
    
    </div>
</div>



<div class="row pt-3" *ngIf="loaded && page === 'fp' && subpage === 'data' && !errorMessage">
    <div class="col-1"></div>
    <div class="col-10">

        <div class="row">
            <div class="col-12">

                <div class="row faketableheaderrow">
                    <div class="col-xl-1 col-lg-1 col-md-2 col-sm-4 col-4 faketableheader" (click)="sortAssets('caseNumber');">
                        Case number <fa-icon [icon]="['fas', 'sort']" class="p-1"></fa-icon>
                    </div>
                    <div class="col-xl-2 col-lg-2 col-md-2 d-none d-md-block faketableheader" (click)="sortAssets('status');">
                        Status <fa-icon [icon]="['fas', 'sort']" class="p-1"></fa-icon>
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-8 col-sm-8 col-8 faketableheader" (click)="sortAssets('subject');">
                        Subject <fa-icon [icon]="['fas', 'sort']" class="p-1"></fa-icon>
                    </div>
                    <div class="col-xl-2 col-lg-2 d-none d-lg-block faketableheader" (click)="sortAssets('whatFalsePositive');">
                        What <fa-icon [icon]="['fas', 'sort']" class="p-1"></fa-icon>
                    </div>
                    <div class="col-xl-2 col-lg-2 d-none d-lg-block faketableheader" (click)="sortAssets('whyFalsePositive');">
                        Why <fa-icon [icon]="['fas', 'sort']" class="p-1"></fa-icon>
                    </div>
                    <div class="col-xl-1 col-lg-1 d-none d-lg-block faketableheader" (click)="sortAssets('whoFalsePositive');">
                        Who <fa-icon [icon]="['fas', 'sort']" class="p-1"></fa-icon>
                    </div>
                </div>

                <div class="row faketablerow" *ngFor="let case of currentMonthDataFP" [routerLink]="['/support/view/' + case.id]" routerLinkActive="activeLink">
                    <div class="col-xl-1 col-lg-1 col-md-2 col-sm-4 col-4 faketablecell">
                        {{case.caseNumber}}
                    </div>
                    <div class="col-xl-2 col-lg-2 col-md-2 d-none d-md-block faketablecell">
                        {{case.status}}
                    </div> 
                    <div class="col-xl-4 col-lg-4 col-md-8 col-sm-8 col-8 faketablecell">
                        {{case.subject}}
                    </div>
                    <div class="col-xl-2 col-lg-2 d-none d-lg-block faketablecell">
                        {{case.whatFalsePositive}}
                    </div>
                    <div class="col-xl-2 col-lg-2 d-none d-lg-block faketablecell">
                        {{case.whyFalsePositive}}
                    </div>
                    <div class="col-xl-1 col-lg-1 d-none d-lg-block faketablecell">
                        {{case.whoFalsePositive}}
                    </div>
                </div>

            </div>
        </div>
    
    </div>
</div>